{
  "_about": "Hand-placed dressing for data/maps/jantar-mantar.json (the asset plan's phase 4), drawn by src/client/dressing.ts. Rows are [sprite key, x, y, tier, mode]: x, y in tiles (the sprite's foot), tier body (3.2, with the people) or structure (2.0, with the cars), mode 'all' (every mode) or 'story' (the story mode's camp scenes; until that mode exists, ?story shows them). Keys are src/client/sprites.json's. Smoke rises only from the cooking fire, at the kitchen's edge, never over the crowd.",
  "map": "Jantar Mantar",
  "smoke": ["oga-camping/camp_fire"],
  "rows": [
    ["auto_rickshaw", 58.1, 48.8, "structure", "all"],
    ["auto_rickshaw_black", 58.9, 48.9, "structure", "all"],
    ["auto_rickshaw", 59.7, 49.0, "structure", "all"],
    ["auto_rickshaw", 6.15, 85.4, "structure", "all"],
    ["auto_rickshaw", 7.05, 85.6, "structure", "all"],

    ["kenney-survival-kit/tent-canvas~2F6FB0", 38.75, 44.0, "body", "story"],
    ["oga-camping/tent~4A6B8A", 39.65, 43.9, "body", "story"],
    ["kenney-survival-kit/tent-canvas~2F6FB0", 41.35, 44.1, "body", "story"],
    ["kenney-survival-kit/tent", 42.35, 44.0, "body", "story"],
    ["kenney-survival-kit/structure-canvas~E8E0CC", 39.55, 44.5, "body", "story"],
    ["kenney-furniture-kit/rugRectangle~2F5D8C", 39.15, 44.9, "body", "story"],
    ["kenney-furniture-kit/rugRounded~8C3B2F", 40.15, 46.1, "body", "story"],

    ["kenney-survival-kit/bedroll~5A6E8C", 38.45, 44.4, "body", "story"],
    ["kenney-survival-kit/bedroll~5A6E8C", 38.7, 44.5, "body", "story"],
    ["book_stall", 41.75, 44.9, "structure", "story"],

    ["kenney-furniture-kit/books", 41.35, 46.3, "body", "story"],
    ["kenney-furniture-kit/books", 42.15, 46.4, "body", "story"],
    ["oga-camping/Cauldron", 43.35, 44.0, "body", "story"],
    ["oga-camping/camp_fire", 44.05, 44.2, "body", "story"],
    ["kenney-food-kit/pot-stew", 43.15, 44.7, "body", "story"],
    ["kenney-food-kit/cup-tea", 42.75, 44.9, "body", "story"],

    ["kenney-food-kit/cup-tea", 42.9, 46.0, "body", "story"],
    ["kenney-food-kit/cup-tea", 43.05, 44.95, "body", "story"],
    ["kenney-survival-kit/barrel", 40.25, 47.4, "body", "story"],
    ["kenney-survival-kit/bucket", 40.65, 47.6, "body", "story"],
    ["kenney-survival-kit/bottle-large", 40.95, 47.5, "body", "story"],

    ["first_aid_box", 41.55, 47.3, "body", "story"],
    ["candles", 38.85, 47.2, "body", "story"],
    ["candles", 39.35, 47.5, "body", "story"]
  ]
}
